import { createContext, useContext } from 'react';
import type { LegalConfig } from '@kitup/brand';

/**
 * The brand's legal bundle, provided next to the brand itself.
 *
 * It arrives as a second argument rather than as a field of `BrandConfig`
 * because its documents are JSX and the API imports the brand: on the brand it
 * would pull React into the API process. Same shape as `BrandContext`, and no
 * default value for the same reason — a page of someone else's requisites is
 * worse than a loud failure.
 */
export const LegalContext = createContext<LegalConfig | null>(null);

export function useLegal(): LegalConfig {
  const legal = useContext(LegalContext);
  if (!legal) throw new Error('BrandProvider is missing above this component in the tree');
  return legal;
}
